<template>
    <v-overlay z-index="201" :value="progress">
        <v-dialog v-model="progress" hide-overlay persistent width="400">
            <v-card style="height:100px;">
                <v-progress-linear style="margin:0px;" height="20" indeterminate color="primary"></v-progress-linear>
                <p style="font-size:20px;padding:15px;margin:0px;">{{ $t('Пожалуйста, подождите...') }}</p>
            </v-card>
        </v-dialog>
    </v-overlay>
</template>
<script>
import { mapState } from 'vuex';
export default {
    computed: {
        ...mapState('base', ['progress'])
    }
};
</script>
